<template>
  <vimeo
    v-if="video.id"
    :video="video.attributes.url"
    :autoplay="autoplay"
  />
</template>

<script>
import { Type } from '@/src/server/helpers/constants'
import Vimeo from './Vimeo'

export default {
  components: { Vimeo },
  props: {
    video: {
      type: Object,
      default () {
        return {}
      },
      validator (value) {
        return !value.id || (value.type === Type.VIDEO && value.attributes && value.attributes.url)
      },
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/server/components/Videos/VideoVimeo.vue